import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { MatAutocompleteHybridComponent } from './mat-autocomplete-hybrid.component';


@NgModule({
    imports: [CommonModule, CoreUiModule, CommonDialogModule, CoreMaterialModule, ReactiveFormsModule],
    declarations: [MatAutocompleteHybridComponent],
    exports: [MatAutocompleteHybridComponent]
})
export class MatAutoCompleteHybridModule { }
